<template>
  <div class="change-state-form bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
    <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
      <div class="ml-4 mt-4">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          {{ actionTitle }} Users
        </h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">
          All of the {{ modelPrettified }} that have been selected will be {{ action }}ed.
        </p>
      </div>
    </div>
    <div class="modal-body">
      <div v-if="errors.length">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="(error, idx) in errors" :key="idx">{{ error }} </li>
        </ul>
      </div>
      <div class="p-6 standard-form">
        <div v-show="action == 'suspend'">
          <div class="standard-field-wrapper">
            <label for="actionReason">Reason for suspending User</label>
            <multiselect class="multiselector"
              v-model="selectedReason"
              :options="options.suspendedReasons"
              placeholder="Select reason for suspending"
              :show-labels="false"
              :multiple="false"
            />
          </div>
          <div class="standard-field-wrapper" v-if="showReasonText">
            <label for="otherReason">Other Reason</label>
            <div class="standard-input-wrapper">
              <div class="standard-input-container">
                <textarea rows="6" name="otherReason" v-model="other_reason_text"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="action-buttons">
        <button type="button" class="btn btn-danger" @click="cancel">Cancel</button>
        <button type="button" class="btn btn-primary" @click="submit" >Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { startCase } from 'lodash-es'
  import Multiselect from 'vue-multiselect'
  import BulkActionService from '@services/BulkActionService'
  import FlashMessages from '@services/FlashMessages'

  export default {
    name: 'assign-reporting-entities-form',
    components: {
      Multiselect,
    },
    data () {
      return {
        selectedReason: null,
        other_reason_text: null,
        processing: false,
        errors: [],
      }
    },
    computed: {
      modelPrettified () {
        return startCase(this.model)
      },
      showReasonText () {
        console.log(this.reasonCode)
        return (this.reasonCode == 'other') ? true : false
      },
      reasonCode () {
        console.log(this.selectedReason)
        return this.selectedReason ? this.selectedReason.toLowerCase() : ''
      },
      hasErrors () {
        return this.errors.length > 0
      },
      action () {
        return this.options.modalType || 'suspend'
      },
      actionTitle () {
        return startCase(this.action)
      },
    },
    methods: {
      cancel () {
        this.$emit('cancel')
      },
      close () {
        this.$emit('close')
      },
      checkForErrors () {
        this.errors = []
        if (!this.selectedReason) {
          this.errors.push('Please select a reason from the drop down')
        }
        if (this.reasonCode == 'other' && !this.other_reason_text ) {
          this.errors.push('Please add an explanation of Other.')
        }
        

      },
      submit () {
        if (this.action == 'unsuspend') {
          this.processing = true
          BulkActionService.unSuspendUser(this.ids, this.model)
            .then(resp => {
              FlashMessages.success(`Unsuspended ${resp.data.result} user(s).`, 'Success')
              this.close()
            })
            .catch(resp => {
              FlashMessages.error(`Failed to unsuspend user(s). Please try again later.`, 'Error')
              this.close()
            })
          
        } else {
          // Normal operation -- Suspend Users
          this.checkForErrors()
          if (!this.processing && !this.hasErrors) {
            this.processing = true
            BulkActionService.suspendUser(this.ids, this.model, this.selectedReason)
              .then(resp => {
                FlashMessages.success(`Suspended ${resp.data.result} user(s).`, 'Success')
                this.close()
              })
              .catch(resp => {
                FlashMessages.error(`Failed to Suspend user(s). Please try again later.`, 'Error')
                this.close()
              })
          }
        }
      },
    },
    created () {
      console.log(this.options)
      console.log(this.options.modalType)
      console.log(this.action)
    },
    props: {
      ids: {
        type: Array,
        required: true,
      },
      model: {
        type: String,
        required: true,
      },
      options: {
        type: Object,
        required: false,
      },
    },
  }
</script>

<style lang="scss">
  .change-state-form {
    .modal-body {
      margin-top: 15px;

      .action-buttons {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
      }
      .multiselector {
        margin-top: 5px;
        min-width: 20rem;
        max-width: 20rem;
      }
    }
  }
</style>
